import eventRepo  from '../services/events';
import courseRepo  from '../services/courses';
import bookingsRepo from '../services/bookings';

export const PROCEED_TO_DELEGATES        = 'PROCEED_TO_DELEGATES';
export const PROCEED_TO_PAYMENT          = 'PROCEED_TO_PAYMENT';
export const PROCEED_TO_CONFIRMATION     = 'PROCEED_TO_CONFIRMATION';
export const BACK_TO_ORGANISATION        = 'BACK_TO_ORGANISATION';
export const BACK_TO_DELEGATES           = 'BACK_TO_DELEGATES';
export const BACK_TO_PAYMENT             = 'BACK_TO_PAYMENT';
export const REFRESH_PAYMENT_EVENT       = 'REFRESH_PAYMENT_EVENT';
export const DELEGATE_ADDED              = 'DELEGATE_ADDED';
export const SHOW_NEW_DELEGATE_FORM      = 'SHOW_NEW_DELEGATE_FORM';
export const HIDE_DELEGATE_FORM          = 'HIDE_DELEGATE_FORM';
export const DELEGATE_REMOVED            = 'DELEGATE_REMOVED';
export const EDIT_DELEGATE               = 'EDIT_DELEGATE';
export const DELEGATE_EDITED             = 'DELEGATE_EDITED';
export const SHOW_BOOKING_SUCCESS        = 'SHOW_BOOKING_SUCCESS';
export const SHOW_GLOBAL_CARD_ERROR      = 'SHOW_GLOBAL_CARD_ERROR';
export const HIDE_GLOBAL_CARD_ERROR      = 'HIDE_GLOBAL_CARD_ERROR';
export const SHOW_GLOBAL_EVENT_ERROR     = 'SHOW_GLOBAL_EVENT_ERROR';
export const HIDE_GLOBAL_EVENT_ERROR     = 'HIDE_GLOBAL_EVENT_ERROR';
export const SHOW_GLOBAL_DELEGATES_ERROR = 'SHOW_GLOBAL_DELEGATES_ERROR';
export const HIDE_GLOBAL_DELEGATES_ERROR = 'HIDE_GLOBAL_DELEGATES_ERROR';
export const PROMOTION_CODE_ADDED        = 'PROMOTION_CODE_ADDED';
export const RESET_PAYMENT_PAGE          = 'RESET_PAYMENT_PAGE';
export const REMOVE_PROMO_CODE           = 'REMOVE_PROMO_CODE';
export const REFRESH_PAYMENT_ELEARNING   = 'REFRESH_PAYMENT_ELEARNING';
export const UPDATE_PROCESSING_ERROR_VISIBILITY = 'UPDATE_PROCESSING_ERROR_VISIBILITY';
export const SET_DUPLICATE_ATTENDEE_EMAIL = 'SET_DUPLICATE_ATTENDEE_EMAIL';
export const COUNTRY_LIST_REFRESHED      = 'COUNTRY_LIST_REFRESHED';
export const SET_BOOKING_COUNTRY         = 'SET_BOOKING_COUNTRY';
export const IS_LOADING_COUNTRIES        = 'IS_LOADING_COUNTRIES';

export function updateProcessingErrorVisibility(show) {
    return {
        type: UPDATE_PROCESSING_ERROR_VISIBILITY,
        show
    }
}

export function resetPaymentPage() {

    return {
        type: RESET_PAYMENT_PAGE
    };
}

export function removePromoCode(promoCode) {

    return {
        type: REMOVE_PROMO_CODE,
        promoCode
    };
}

export function promotionCodeAdded(promoCode) {

    return {
        type: PROMOTION_CODE_ADDED,
        promoCode
    };
}

export function hideGlobalDelegatesError() {

    return {
        type: HIDE_GLOBAL_DELEGATES_ERROR
    };
}

export function showGlobalDelegatesError(errorMessage) {

    return {
        type: SHOW_GLOBAL_DELEGATES_ERROR,
        errorMessage
    };
}

export function hideGlobalCardError() {

    return {
        type: HIDE_GLOBAL_CARD_ERROR
    };
}

export function showGlobalCardError(errorMessage) {

    return {
        type: SHOW_GLOBAL_CARD_ERROR,
        errorMessage
    };
}

export function hideGlobalEventError() {

    return {
        type: HIDE_GLOBAL_EVENT_ERROR
    };
}

export function showGlobalEventError(errorMessage) {

    return {
        type: SHOW_GLOBAL_EVENT_ERROR,
        errorMessage
    };
}

export function showBookingSuccess() {

    return {
        type: SHOW_BOOKING_SUCCESS
    };
}

export function backToDelegates() {

    return {
        type: BACK_TO_DELEGATES
    };
}

export function backToOrganisation() {

    return {
        type: BACK_TO_ORGANISATION
    };
}

export function backToPayment() {

    return {
        type: BACK_TO_PAYMENT
    };
}

export function delegateEdited(delegate) {

    return {
        type: DELEGATE_EDITED,
        delegate
    };
}

export function editDelegate(delegate) {

    return {
        type: EDIT_DELEGATE,
        delegate
    };
}

export function proceedToPayment() {

    return {
        type: PROCEED_TO_PAYMENT
    };
}

export function removeDelegate(delegateIndex) {

    return {
        type: DELEGATE_REMOVED,
        delegateIndex
    };
}

export function hideDelegateForm() {

    return {
        type: HIDE_DELEGATE_FORM
    }; 
}

export function showNewDelegateForm() {

    return {
        type: SHOW_NEW_DELEGATE_FORM
    };
}

export function delegateAdded(delegate) {

    return {
        type: DELEGATE_ADDED,
        delegate
    }
}

export function getSectionOffset(elId, removeHeight) {
    let rect = document.getElementById(elId).getBoundingClientRect(),
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    return rect.top + scrollTop - removeHeight;
}

export function getCountry(countryId) {

    return (dispatch) => {

        function getSuccess(response) {

            return dispatch(setCountry(response.data.data));
        }

        return bookingsRepo.getCountry(countryId)
            .then(getSuccess);
    }
}

export function refreshPaymentEvent(eventId) {

    return (dispatch) => {

        function getSuccess(response) {

            return dispatch(paymentEventRefreshed(response.data.data));
        }

        eventRepo.getOne(eventId)
            .then(getSuccess);
    };
}

export function refreshPaymentELearningCourse(courseId) {
    return (dispatch) => {
        function getSuccess(response) {

            return dispatch(paymentELearningRefreshed(response.data.data));
        }

        courseRepo.getOne(courseId)
            .then(getSuccess);
    };
}

export function getCountryList() {
    return (dispatch) => {
        function getSuccess(response) {
            dispatch(countryListRefreshed(response.data.data));
            dispatch(isLoadingCountries(false));
        }

        dispatch(isLoadingCountries(true));

        return bookingsRepo.getCountries()
            .then(getSuccess);
    }
}

export function isLoadingCountries(isLoading) {

    return {
        type: IS_LOADING_COUNTRIES,
        isLoading
    }
}

export function paymentELearningRefreshed(eLearningCourse) {

    return {
        type: REFRESH_PAYMENT_ELEARNING,
        eLearningCourse
    };
}

export function paymentEventRefreshed(event) {

    return {
        type: REFRESH_PAYMENT_EVENT,
        event
    };
}

export function setCountry(country) {

    return {
        type: SET_BOOKING_COUNTRY,
        country
    };
}

export function proceedToDelegates(formValues) {

    return {
        type: PROCEED_TO_DELEGATES,
        formValues
    };
}

export function proceedToConfirmation(formValues) {

    return {
        type: PROCEED_TO_CONFIRMATION,
        formValues
    };
}

export function setDuplicateAttendeeEmail(isDuplicate) {

    return {
        type: SET_DUPLICATE_ATTENDEE_EMAIL,
        isDuplicate
    }
}

export function countryListRefreshed(countries) {

    return {
        type: COUNTRY_LIST_REFRESHED,
        countries
    };
}


// WEBPACK FOOTER //
// ./actions/payment.js